import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../foundations/icons/Icon.js";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { CheckboxBase } from "../../input/elements/unstyled/CheckboxBase/CheckboxBase.js";
import { useCheckboxGroupProvider } from "../../input/elements/unstyled/CheckboxBase/hooks/useCheckboxContext.js";
import { s as styles } from "../../../chunks/Badge.module-BQ48tBve.js";
const BadgeCheckbox = forwardRef(
  ({ children, value, className, isSelected, ...props }, ref) => {
    const groupContext = useCheckboxGroupProvider();
    const state = groupContext == null ? void 0 : groupContext.state;
    return /* @__PURE__ */ jsx(
      CheckboxBase,
      {
        ref,
        value,
        className: clsx(styles.badge, styles.badgeCheckbox, className),
        selectedClassName: clsx(styles.badgeIsSelected, styles.badgeIsDismissible),
        pressedClassName: styles.badgeIsPressed,
        focusedClassName: styles.badgeIsFocused,
        ...props,
        children: /* @__PURE__ */ jsxs(Text, { variant: "text-body-head", component: "span", className: styles.badgeText, children: [
          children,
          (state == null ? void 0 : state.isSelected(value)) || isSelected ? /* @__PURE__ */ jsx(Icon, { variant: "XSmall", "aria-hidden": true }) : null
        ] })
      }
    );
  }
);
export {
  BadgeCheckbox
};
